import React from 'react';
import { isOwnerOrAdmin } from '../../utils/RoleManager';
import { useDemoData } from './demoData';
import useDemoDataRemoval from './useDemoDataRemoval';
import useTrialDemoCompact from './useTrialDemoCompact';
import TrialDemoCompactBanner from './TrialDemoCompactBanner';
import styles from './DemoDataBanner.module.css';

/**
 * Faixa dos dados de exemplo (docs/features/trial-demo-data, seção 3), logo abaixo
 * da faixa do teste. Só durante o teste e com exemplo presente; o botão de remover
 * é de proprietário(a) e administrador(a) (R5). Some sozinha depois da remoção.
 * No celular, com a faixa do teste junto, vira a faixa única TrialDemoCompactBanner.
 * element (confirmação e aviso) fica sempre montado: o aviso aparece depois que a faixa some.
 */
const DemoDataBanner = () => {
  // isOwnerOrAdmin() lê o DataProvider (hook): só no corpo do componente
  const canRemove = isOwnerOrAdmin();
  const { removable } = useDemoData();
  const { requestRemoval, removing, element } = useDemoDataRemoval();
  const { compact, trial } = useTrialDemoCompact();

  if (!removable) return element;

  if (compact) {
    return (
      <>
        <TrialDemoCompactBanner trial={trial} canRemove={canRemove} removing={removing} onRemove={requestRemoval} />
        {element}
      </>
    );
  }

  return (
    <>
      <div className={styles.banner} data-tour="demo-banner">
        <span className={`${styles.message} ${styles.full}`}>
          Esta conta tem dados de exemplo para você conhecer as telas. Eles não enviam mensagens nem
          contam como uso. Antes de começar de verdade, remova tudo.
        </span>
        <span className={`${styles.message} ${styles.short}`}>Conta com dados de exemplo</span>
        {canRemove && (
          <button type="button" className={styles.ctaButton} onClick={requestRemoval} disabled={removing}>
            {removing ? 'Removendo...' : (
              <>
                <span className={styles.full}>Remover dados de exemplo</span>
                <span className={styles.short}>Remover</span>
              </>
            )}
          </button>
        )}
      </div>
      {element}
    </>
  );
};

export default DemoDataBanner;
